/**
 * Constants related to the status of web register.
 */

export const POS_STATUS_URL = '/pos/status.json'

export enum STATUS {
  ONLINE = 'ONLINE',
  UNREACHABLE = 'UNREACHABLE',
  REMOTE_DISABLED = 'REMOTE_DISABLED',
  LOCAL_DISABLED = 'LOCAL_DISABLED',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
}

export enum EVENTS {
  statusChange = 'webRegisterStatusChange',
  transitionOnline = 'webRegisterTransitionOnline',
  transitionOffline = 'webRegisterTransitionOffline',
  insufficientStateForOffline = 'webRegisterInsufficientStateForOffline',
  softRefreshRequired = 'webRegisterSoftRefreshRequired',
  restrictedAccessChange = 'webRegisterRestrictedAccessChange',
}

export enum SALES_STATUS {
  VEND_ERROR_SALES_COUNT = 'VEND_ERROR_SALES_COUNT',
}
